import { RouteConfig } from '../../routing/types'

export type PathArgs = unknown[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'signup',
  path: () => '/signup',
  type: 'public',
}

export default ROUTE
